import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-QR_download",
  "use": "icon-QR_download-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-QR_download\">\n<path d=\"M5 16.125V22.875H23V16.125\" stroke=\"\" stroke-width=\"1.5\" />\n<path d=\"M14 6V15\" stroke=\"\" stroke-width=\"1.5\" />\n<path d=\"M13.9998 18.8571L10.1427 15L17.857 15L13.9998 18.8571Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol